export default function fixed(value, decimals) {
  const divider = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * divider) / divider;
}
